import { ActionIcon, Tooltip } from '@mantine/core';
import { AiOutlineUserAdd } from 'react-icons/ai';

interface AddToContactsButtonProps {
    onClick: () => void;
}

export const AddToContactsButton = ({ onClick }: AddToContactsButtonProps) => {
    return (
        <Tooltip label="Add to Contacts">
            <ActionIcon variant="subtle" size="sm" onClick={onClick}>
                <AiOutlineUserAdd />
            </ActionIcon>
        </Tooltip>
    );
};
